export function generateMaze(width, height) {
  // Initialize with walls (1)
  const maze = Array(height).fill().map(() => Array(width).fill(1));
  
  const directions = [
    [0, -2], [0, 2], [-2, 0], [2, 0]
  ];
  
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  
  function carve(x, y) {
    maze[y][x] = 0;
    
    const dirs = shuffle([...directions]);
    
    for (const [dx, dy] of dirs) {
      const nx = x + dx;
      const ny = y + dy;
      
      if (nx > 0 && nx < width - 1 && ny > 0 && ny < height - 1 && maze[ny][nx] === 1) {
        maze[y + dy/2][x + dx/2] = 0;
        carve(nx, ny);
      }
    }
  }
  
  // Start from 1,1
  carve(1, 1);
  
  // Add some loops for arcade feeling (remove dead ends)
  for (let y = 1; y < height - 1; y++) {
    for (let x = 1; x < width - 1; x++) {
      if (maze[y][x] === 1) {
        // If it's a wall surrounded by 2 or more paths, maybe break it
        let pathNeighbors = 0;
        if (maze[y-1][x] === 0) pathNeighbors++;
        if (maze[y+1][x] === 0) pathNeighbors++;
        if (maze[y][x-1] === 0) pathNeighbors++;
        if (maze[y][x+1] === 0) pathNeighbors++;
        
        if (pathNeighbors >= 2 && Math.random() < 0.15) { // 15% chance to open loops
          maze[y][x] = 0;
        }
      }
    }
  }
  
  return maze;
}